export default __webpack_public_path__ + "df2487479a62dde369c0133fbd8b6597.png";